import { MergedFeaturePoint } from '../merged-feature-point.model';

export enum VesselSource {
  AIS = 'AIS',
  RISK_INTELLIGENCE = 'RISK_INTELLIGENCE',
}

export interface Vessel extends Partial<MergedFeaturePoint> {
  vessel_id: string;
  name: string;
  imo?: number | string;
  mmsi?: number | string;
  heading?: number;
  latitude: number;
  longitude: number;
  callsign?: string;
  shiptype?: string;
  // TODO: these should be numbers, but Alerts API returns string and History API returns number...
  course: number;
  speed?: number;
  source: VesselSource;
  timestamp?: string | number;
}

export interface RevolutionsVessel {
  ship_id: string;
  ship_imo: string;
  name: string;
  built_year: string;
  gross_tonnage: string;
  type_code: string;
  type_description: string;
  flag_code: string;
  flag_description: string;
  place_of_management_code: string;
  place_of_management_description: string;
  insurer_label: string;
  insurer_value: string;
  vessel_group_label: string;
  vessel_group_value: string;
  vessel_member_label: string;
  vessel_member_value: string;
  on_risk: boolean;
  last_updated_date: string;
  last_updated_time: string;
  derived_information: {
    vessel_type: string;
  };
}
